<crud-list class="col-12" [data]="table" detailUrl="/enaio-learn/admin/learning-content-category/" restUrl="api/lrn/learningcontentcategory">
</crud-list>
